/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsProgramBoardsType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/ProgramBoards.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/program-boards/types.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - removed-issues page
 */

export const LazyPlanSettingsProgramBoards: LazyComponent<(props: Props) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsProgramBoardsType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-program-boards", jiraSpaEntry: "async-plan-settings-program-boards" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/ProgramBoards.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsProgramBoards = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsProgramBoards}
		pageId="plan-settings-program-boards"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsProgramBoards;
